import { render } from "./ApprovalsView.vue?vue&type=template&id=4edc3c9d"
import script from "./ApprovalsView.vue?vue&type=script&lang=js"
export * from "./ApprovalsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__